/**
 * FAQ Main - JavaScript
 * Handles accordion expand/collapse functionality
 */

class FAQMain {
  constructor() {
    this.init();
  }

  init() {
    this.setupAccordion();
  }

  setupAccordion() {
    const faqToggles = document.querySelectorAll('[data-faq-toggle]');

    faqToggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const faqItem = toggle.closest('.faq-main__item');
        const isActive = faqItem.classList.contains('active');

        // Close all other FAQ items
        document.querySelectorAll('.faq-main__item').forEach((item) => {
          if (item !== faqItem) {
            item.classList.remove('active');
          }
        });

        // Toggle current item
        if (isActive) {
          faqItem.classList.remove('active');
        } else {
          faqItem.classList.add('active');
        }
      });

      // Add keyboard support
      toggle.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle.click();
        }
      });

      // Make it focusable
      toggle.setAttribute('tabindex', '0');
      toggle.setAttribute('role', 'button');
      toggle.setAttribute('aria-expanded', 'false');
    });

    // Update aria-expanded when items are toggled
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          const item = mutation.target;
          const toggle = item.querySelector('[data-faq-toggle]');
          const isActive = item.classList.contains('active');
          if (toggle) {
            toggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          }
        }
      });
    });

    document.querySelectorAll('.faq-main__item').forEach((item) => {
      observer.observe(item, { attributes: true });
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FAQMain();
  });
} else {
  new FAQMain();
}
